import { isEmpty } from "@/backend/helpers/utils";
import { CustomField } from "./customField";
import { REGEX, testRegex } from "@/backend/lib/regex";

export class IntCustomField extends CustomField {
  formatFromRead() {
    this.formatDefaultValue();
    this.formatCustomValue();
  }

  formatDefaultValue() {
    if (isEmpty(this.defaultValue)) {
      this.defaultValue = undefined;
      return;
    };
    const parsedDefaultValue = parseInt(this.defaultValue as string);
    if (!Number.isNaN(parsedDefaultValue)) {
      this.defaultValue = parsedDefaultValue;
    }
  }

  formatCustomValue() {
    this.customValue = parseInt(this.customValue as string);
    if (Number.isNaN(this.customValue)) {
      this.customValue = undefined;
    }
  }

  hasValidDefaultInput() {
    if (this.defaultValue === undefined || this.defaultValue === null) return true;
    return testRegex(REGEX.integer, this.defaultValue.toString());
  }

  hasValidCustomInput() {
    if (this.customValue === undefined || this.customValue === null) return true;
    return testRegex(REGEX.integer, this.customValue.toString());
  }
}
